import {colorShades, colourPalette} from "../../../utils/uiUtils";

export const variantColorMap = {
    defValue: {
        headerColor: colourPalette[0],
        ...colorShades(colourPalette[0])
    },
    ageOfFilesData: {
        headerColor: colourPalette[0],
        ...colorShades(colourPalette[0])
    },
    filesTypeData: {
        headerColor: colourPalette[1],
        ...colorShades(colourPalette[1])
    },
    otherReservedVariant1: {
        headerColor: colourPalette[2],
        ...colorShades(colourPalette[2])
    },
    otherReservedVariant3: {
        headerColor: colourPalette[3],
        ...colorShades(colourPalette[3])
    },
};
